import React from "react";
import PageLayout from "./PageLayout";
import { IConfig } from "../config/IConfig";
import { trackEvent } from "../utils/amplitude";

interface IChatWindow {
  license?: number;
  group?: number;
  test?: number;
}

interface ILCApi {
  on_after_load?(): void;
  agents_are_available?(): boolean;
  on_chat_started?(): void;
  on_chat_state_changed?(data: any): void;
}

interface IWindow {
  __lc?: IChatWindow;
  LC_API?: ILCApi;
}

const handleInit = (
  config: IConfig,
  licenseId: number,
  groupId?: number
): void => {
  const mainWindow = window as IWindow;

  mainWindow.__lc = {
    license: licenseId,
    group: groupId,
    test: config.dontTrackLicenseActivity ? 1 : 0
  };

  (function() {
    var lc = document.createElement("script");
    lc.type = "text/javascript";
    lc.async = true;
    lc.src =
      ("https:" === document.location.protocol ? "https://" : "http://") +
      config.trackingCodeUrl;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode!.insertBefore(lc, s);
  })();
};

interface IProps {
  header: string;
  config: IConfig;
  licenseId: number;
  groupId?: number;
}

const PreviewPage: React.FC<IProps> = ({
  header,
  licenseId,
  groupId,
  config
}) => {

  React.useEffect(() => {
    const mainWindow = window as IWindow;
    mainWindow.LC_API = {
      on_chat_started() {
        trackEvent("Sample page: Chat started", { license: licenseId });
      }
    };
    handleInit(config, licenseId, groupId);
  }, [config, licenseId, groupId]);

  return (
    <PageLayout
      header={header}
      message="This is a live preview of your LiveChat widget."
    />
  );
};

export default PreviewPage;
